export default {
  Order: 1,
  Processing: 2,
  Delivered: 3,
  Cancelled: 4,
  Invoiced: 5,
}